import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/component-showcase')({
  staticData: { hideShell: true },
});
